import { render, staticRenderFns } from "./RecordingMergeRequests.vue?vue&type=template&id=65f22965&"
import script from "./RecordingMergeRequests.vue?vue&type=script&lang=js&"
export * from "./RecordingMergeRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports